export class RestoreAccountAttributesInput {
    'cloudProvider';
    'aws';
    'azure';
    'gcp';
    'mongoAtlas';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsRestoreAccountAttributesInput",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "AzureRestoreAccountAttributesInput",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpRestoreAccountAttributesInput",
            "format": ""
        },
        {
            "name": "mongoAtlas",
            "baseName": "mongoAtlas",
            "type": "MongoAtlasRestoreAccountAttributesInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
